"use strict";

/**
 * The ValueCache holds one value and the variables
 * used to calculate the value. To get the value,
 * call valueCache.value after checking that isSame()
 * returns true.
 * 
 * This can accept an options object with an equals
 * function. If given, this function will be given the
 * currenct argument the last argument at the same index, 
 * and the index. If it should return true or false depending
 * on whethere or not the two objects are considered to be
 * equal. If not supplied, the '===' will be used.
 **/
class ValueCache {
  constructor(options = {}) {
    this.conditions = [];
    this.value = null;
    this.equals = options.equals;
    this.hasCalc = false;
  }
  /**
   * Returns true if the supplied conditions
   * are the same as the ones given last time
   * @param {...any} conditions the variables used to
   * decide whether or not the cached value can be reused
   * @return {boolean} true if the cached value can be used
   **/


  isSame(...conditions) {
    if (conditions.length === this.conditions.length) {
      for (let n = 0; n < conditions.length; n++) {
        if (this.equals) {
          if (!this.equals(conditions[n], this.conditions[n], n)) {
            return false;
          }
        } else if (conditions[n] !== this.conditions[n]) {
          return false;
        }
      }

      return true;
    }

    return false;
  }
  /**
   * Sets the cached values and the variable used
   * to compute it. The value is returned
   * @param {any} value the value to cache
   * @param {...any} the variables used to compute the value
   * @return {any} the value
   **/


  set(value, ...conditions) {
    this.value = value;
    this.conditions = conditions;
    return value;
  }
  /**
   * Clears the cached value and the conditions
   **/


  clear() {
    this.conditions = [];
    this.value = null;
  }
  /**
   * Optional way of using ValueCache to check and compute in one step
   * @param {function} compute a function of form function( ...conditions )
   * that computes and returns the value
   * @param {...any} conditions the set of conditions that define the value
   * @return {any} either the cached value or the newly computed one
   **/


  calc(compute, ...conditions) {
    if (this.hasCalc && this.isSame(...conditions)) {
      return this.value;
    }

    this.hasCalc = true;
    this.value = compute(...conditions);
    return this.set(this.value, ...conditions);
  }

}

module.exports = ValueCache;